import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { useUGGApiVersions } from "../ugg-api-versions";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getApiRoot } from "@ugg/shared/api/api-helpers";
import { cleanDuosData } from "@ugg/shared/api/data-parser/champions/duos";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

import { Duos } from "@ugg/shared/interfaces/champions/duos.interface";

export function useChampionDuosURL(championId: number, options: { queueType?: string; patch?: string }) {
  const { queueType, patch } = options;
  const { data: version } = useUGGApiVersions({ apiKey: "champion_duos", patch });
  const root = getApiRoot(options.patch);

  return [`${root}/champion_duos`, patch, queueType, championId, `${version}.json`].join("/");
}

export function useChampionDuos(
  championId: number,
  options?: { params?: Record<string, any> } & JSONFetcherOptions<Duos, ReturnType<typeof cleanDuosData>>,
) {
  const { params = {}, ssr = false, skip = false } = options || {};
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(CHAMPION_PAGES.DUOS, params, true);

  const championDuosURL = useChampionDuosURL(championId, validatedQueryParams);
  return useJSONFetcher<Duos, ReturnType<typeof cleanDuosData>>(championDuosURL, {
    ssr,
    skip,
    onCompleted: (url, json) => cleanDuosData(json),
  });
}
